import { render, staticRenderFns } from "./anlilist.vue?vue&type=template&id=827fb19e&scoped=true&"
import script from "./anlilist.vue?vue&type=script&lang=js&"
export * from "./anlilist.vue?vue&type=script&lang=js&"
import style0 from "./anlilist.vue?vue&type=style&index=0&id=827fb19e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "827fb19e",
  null
  
)

export default component.exports